import Navigation from './layout/Navigation';
import LandingFooter from './layout/CareerFooter';
import CareersHero from './components/CareersHero/CareersHero';
import CareersSection from './components/CareersSection/CareersSection';

export default function CareersPage() {
  return (
    <>
      <Navigation />
      <main>
        <CareersHero />
        <CareersSection />
      </main>
      <LandingFooter />
    </>
  );
}
